import React, { useContext, useEffect, useState } from 'react';

import { ADDRESS_SOURCES } from './addressServices';
import { AuthContext } from '../authentication/AuthContext';

const DEFAULT_ADDRESS_STATE = {
  isLoading: false,
  regions: [],
  provinces: [],
  districts: [],
  subdistricts: [],
  postalCodes: [],
};

export const AddressContext = React.createContext(DEFAULT_ADDRESS_STATE);

export const AddressProvider = ({ children }) => {
  const [state, setState] = useState(DEFAULT_ADDRESS_STATE);
  const { admin } = useContext(AuthContext);

  async function fetchData(sources) {
    setState({ ...state, isLoading: true });

    await Promise.all(sources.map(({ service }) => service.fetch()))
      .then((results) => {
        setState(
          sources.reduce(
            (acc, value, index) => ({
              ...acc,
              [value.name]: results[index].data,
            }),
            { ...state, isLoading: false },
          ),
        );
      })
      .catch((err) => {
        alert('There was an error fetching address');
        throw err;
      });
  }

  function getOnCreate(entityName) {
    const source = ADDRESS_SOURCES[entityName];

    return async (args) => {
      try {
        await source.service.create(args);
        await fetchData([source]);
      } catch (err) {
        console.error('There was an error fetching address', err);
      }
    };
  }

  function getOnEdit(entityName) {
    const source = ADDRESS_SOURCES[entityName];

    return async (args) => {
      await source.service.update(args);

      try {
        await fetchData([source]);
      } catch (err) {
        console.error('There was an error fetching address', err);
      }
    };
  }

  useEffect(() => {
    if (admin) {
      fetchData(Object.values(ADDRESS_SOURCES));
    }
  }, [admin]);

  return (
    <AddressContext.Provider value={{ ...state, getOnCreate, getOnEdit }}>
      {children}
    </AddressContext.Provider>
  );
};
